var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"centerRight1"}},[_c('dv-scroll-board',{staticClass:"dv-scr-board",staticStyle:{"width":"380px","height":"240px"},attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }